'use strict';

class commonService {
  constructor($http, I18N) {
    this.$http = $http;
    this.I18N = I18N;
  }

  getCountries() {
    return this.$http.get(`/common/public/countries`, {
      cache: true
    }).then((resp) => resp.data);
  }

  getCityByPostCode(code) {
    return this.$http.get(`/common/public/postNumber/${code.replace(/[^0-9.]/g, '')}`);
  }

  getOrganisationForms() {
    return this.$http.get(`/common/public/organisationForms`, {
      cache: true
    }).then((resp) => resp.data);
  }

  getExchangeRates() {
    return this.$http.get(`/common/currency/exchangeRates`)
      .then((resp) => resp.data);
  }

  getConstants() {
    return this.$http.get(`/common/constants`, {
      cache: true
    }).then((resp) => resp.data);
  }

  getPrices() {
    return this.$http.get(`/common/prices`)
      .then((resp) => resp.data);
  }

  getPricesResend() {
    return this.$http.get(`/common/prices/resend`)
      .then((resp) => resp.data);
  }

  getDifi(query) {
    return $.getJSON(`//hotell.difi.no/api/json/brreg/enhetsregisteret?query=${query}`);
  }

  datePicker(options) {
    return new Pikaday(angular.extend(options, {
      format: options.format ? options.format : 'DD.MM.YY',
      i18n: this.I18N.datepicker
    }));
  }
}

commonService.$inject = ['$http', 'I18N'];

angular
  .module('SendRegning')
  .service('commonService', commonService);
